import { ChangeEvent, useEffect, useState } from 'react';
import { TextInput } from '../../Calculators/calculator-revamp/components/form-components/InputBox';
import { SelectInput } from '../../Calculators/calculator-revamp/components/form-components/SelectBox';
import { AtcBusinessProfits } from '../Atc-calculator-constants';
import { BusinessProfessions, CALCULATOR_TAB_PROPS } from '../types';
import { removeCommas } from '../../Utils/CommonUtils';

const AtcBusinessIncome = ({
  hasError,
  setGlobalError,
  setInputData,
  inputTabData,
}: CALCULATOR_TAB_PROPS) => {
  const [inputRows, setInputRows] = useState({
    BusinessProfessions: inputTabData?.BusinessProfessions || [
      { id: 1, Type: 'PresumptiveBusiness', Amount: '' },
    ],
  });

  const [lastId, setlastId] = useState(() => {
    const businessProfessions = Array.isArray(inputTabData?.BusinessProfessions)
      ? inputTabData.BusinessProfessions
      : [];
    return businessProfessions.length
      ? businessProfessions[businessProfessions.length - 1]?.id
      : 1;
  });

  const handleAddRow = () => {
    setInputRows((prevState) => {
      const businessProfessionArray = Array.isArray(
        prevState.BusinessProfessions
      )
        ? (prevState.BusinessProfessions as BusinessProfessions[])
        : [];
      return {
        BusinessProfessions: [
          ...businessProfessionArray,
          {
            id: (lastId || 0) + 1,
            Type: 'PresumptiveBusiness',
            Amount: '',
          },
        ],
      };
    });
    setlastId((prevId) => (prevId || 0) + 1);
  };

  const handleRemoveRow = (id: number) => {
    setInputRows((prevState) => {
      const businessProfessionArray = Array.isArray(
        prevState.BusinessProfessions
      )
        ? (prevState.BusinessProfessions as BusinessProfessions[])
        : [];
      return {
        BusinessProfessions: businessProfessionArray.filter(
          (row) => row.id !== id
        ),
      };
    });
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>, id: number) => {
    const key = e.target.id;
    const value = removeCommas(e.target.value);
    setInputRows((prevState) => {
      const businessProfessionArray = Array.isArray(
        prevState.BusinessProfessions
      )
        ? (prevState.BusinessProfessions as BusinessProfessions[])
        : [];
      const updatedRows = businessProfessionArray.map((row) =>
        row.id === id ? { ...row, [key]: value } : row
      );

      return { ...prevState, BusinessProfessions: updatedRows };
    });
  };

  const handleChangeInput = (
    key: string,
    value: number | string,
    id: number
  ) => {
    setInputRows((prevState) => {
      const businessProfessionArray = Array.isArray(
        prevState.BusinessProfessions
      )
        ? (prevState.BusinessProfessions as BusinessProfessions[])
        : [];
      const updatedRows = businessProfessionArray.map((row) =>
        row.id === id ? { ...row, [key]: value } : row
      );

      return { ...prevState, BusinessProfessions: updatedRows };
    });
  };

  useEffect(() => {
    setInputData?.((prevState) => ({
      ...prevState,
      BusinessProfessions: inputRows.BusinessProfessions,
    }));
  }, [inputRows, setInputData]);

  return (
    <>
      <div className="font-bold text-base mb-3  sm:mb-6 sm:mt-2">
        Profits from Business or Profession
      </div>
      {Array.isArray(inputRows.BusinessProfessions) &&
        inputRows.BusinessProfessions.map((row) => (
          <div
            key={row.id}
            className="flex gap-12 sm:mb-6 sm:flex-col sm:gap-0 sm:items-end justify-center"
          >
            <div
              className={`flex w-full sm:w-full gap-12 sm:block py-3 sm:py-0`}
            >
              {AtcBusinessProfits.map((props, index) => {
                if (props.type === 'text') {
                  return (
                    <div key={index} className="w-1/2 sm:w-full font-medium">
                      <TextInput
                        {...props}
                        value={
                          Array.isArray(inputTabData?.BusinessProfessions)
                            ? (
                                inputTabData.BusinessProfessions as BusinessProfessions[]
                              ).find((dataRow) => dataRow.id === row.id)
                                ?.Amount || ''
                            : ''
                        }
                        hasError={hasError}
                        setGlobalError={setGlobalError}
                        onTextChangeFn={(e) => handleChange(e, row.id)}
                      />
                    </div>
                  );
                } else {
                  return (
                    props.value !== undefined && (
                      <div key={index} className="w-1/2 sm:w-full font-medium">
                        <SelectInput
                          {...props}
                          value={
                            Array.isArray(inputTabData?.BusinessProfessions)
                              ? (
                                  inputTabData.BusinessProfessions as BusinessProfessions[]
                                ).find((dataRow) => dataRow.id === row.id)
                                  ?.Type || ''
                              : ''
                          }
                          onChange={(fieldName, value) =>
                            handleChangeInput(fieldName, value, row.id)
                          }
                        />
                      </div>
                    )
                  );
                }
              })}
            </div>

            {row.id === lastId ? (
              <div className="flex items-center">
                <a
                  className="cursor-pointer text-blue-350"
                  onClick={handleAddRow}
                >
                  <img
                    className="h-8 w-8"
                    src="https://assets.clear.in/cleartax/images/1728584454_pluscircle.svg"
                    alt=""
                  />
                </a>
              </div>
            ) : (
              <div className="flex items-center w-[3.5%] justify-center sm:w-[9%]">
                <a
                  className="text-s-32 font-semibold flex items-center cursor-pointer"
                  onClick={() => handleRemoveRow(row.id)}
                >
                  <img
                    className="h-8 w-9"
                    src="https://assets.clear.in/cleartax/images/1729620942_minuscircle.svg"
                    alt=""
                  />
                </a>
              </div>
            )}
          </div>
        ))}
    </>
  );
};

export default AtcBusinessIncome;
